import React from 'react';
import { connect } from 'react-redux';
import EnhancedDataTable from '../../components/MaterialUi/DataTable/EnhancedDataTable';
import * as actions from '../../redux/projApollo/actions';
import Button from 'material-ui/Button';
import KeyboardArrowUp from 'material-ui-icons/KeyboardArrowUp';
import KeyboardArrowDown from 'material-ui-icons/KeyboardArrowDown';
//import ModeEdit from 'material-ui-icons/ModeEdit';
//import Add from 'material-ui-icons/Add';
import Delete from 'material-ui-icons/Delete';
//import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import ActionConfirmDialog2 from '../../components/ActionConfirmDialog/ActionConfirmDialog2';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import Paper from 'material-ui/Paper'
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
                        
const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '1px', width: '13%'}, noHeader: true },
    { id: 'item_row_index', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '5px', width: '1%'}, noHeader: false },
    { id: 'hdr_acct_no', numeric: false, disablePadding: true, label: 'Col. H (Hdr. Acct. No.)', customCol: true, style: { paddingLeft: '10px', paddingRight: '10px',  width: '5%'},noHeader: false },
    { id: 'hdr_total', numeric: false, disablePadding: true, label: 'Col. I (Hdr. Total)', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '5%'},noHeader: false },
    { id: 'hdr_consumption', numeric: false, disablePadding: true, label: 'Col. J (Hdr. Cons.)', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '6%'},noHeader: false },
    { id: 'hdr_consumption_unit', numeric: false, disablePadding: true, label: 'Col. K (Hdr. Cons. Units)', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '6%'},noHeader: false },
    { id: 'item_charge_desc', numeric: false, disablePadding: true, label: 'Col. L (Item Charge Desc.)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '22%' },noHeader: false },
    { id: 'item_charge', numeric: false, disablePadding: true, label: 'Col. M (Charge)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '5%' },noHeader: false },
    { id: 'item_consumption', numeric: false, disablePadding: true, label: 'Col. N (Consumption)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '6%' },noHeader: false },
    { id: 'item_consumption_unit', numeric: false, disablePadding: true, label: 'Col. O (Consumption Unit)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '6%' },noHeader: false },
    { id: 'item_service_addr', numeric: false, disablePadding: true, label: 'Col. P (Service Address)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '7%' },noHeader: false },
    { id: 'item_bill_start_date', numeric: false, disablePadding: true, label: 'Col. Q (Bill. Start Date)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '6%' },noHeader: false },
    { id: 'item_bill_end_date', numeric: false, disablePadding: true, label: 'Col. R (Bill. End Date)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '6%' },noHeader: false },
    { id: 'item_partial_or_final', numeric: false, disablePadding: true, label: 'Col. S (Partial/Final)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '3%' },noHeader: false },
    { id: 'item_days_of_service', numeric: false, disablePadding: true, label: 'Col. T (Days of Service)',customCol: true,style: { paddingLeft: '11px', paddingRight: '11px',width: '3%' },noHeader: false }
];

const editApolloItem=(id,props)=>{
    const { projApollo } = props;
    const apolloItem = projApollo.apolloItems.find(item => item.id==id)
    
    props.editApolloItem(apolloItem);
}

const moveDownApolloItem=(id,props)=>{
    const { jwt } = props;
    props.moveDownApolloItem(jwt,id);
}

const moveUpApolloItem=(id,props)=>{
    const { jwt } = props;
    props.moveUpApolloItem(jwt,id);
}

const deleteApolloItem=(id,props)=>{
    props.selectApolloItemId(id);
    props.deleteActionDialog();
}

const submitConfirmDelete=(props)=>{
    const { jwt,projApollo } = props;
    props.deleteApolloItem(jwt,projApollo.apolloItemId);
    props.closeDeleteDialog();
}

const customCol = (col,row,props)=>{
    const { projApollo } = props;
    switch(col.id){
      case 'id':
        const itemIndex=projApollo.apolloItems.findIndex(item => item.id==row.id)
        const isFirstItem=itemIndex==0?true:false;
        const isLastItem=(itemIndex==projApollo.apolloItems.length-1 && projApollo.page==projApollo.pages)?true:false;
       // const allowToDelete=isLastItem?false:true;
        return (
           <div>
             <Tooltip id="tooltip-icon" title="Move Up">
              <div>  
                <Button variant="fab" disabled={isFirstItem} mini aria-label="Move Up" onClick={()=> moveUpApolloItem(row.id,props)}  >
                    <KeyboardArrowUp />
                </Button>
              </div> 
             </Tooltip>
             <Tooltip id="tooltip-icon" title="Move Down">
               <div>    
                <Button variant="fab" mini disabled={isLastItem} aria-label="Move Down" onClick={()=> moveDownApolloItem(row.id,props)} >
                    <KeyboardArrowDown />
                </Button>
               </div>
             </Tooltip>
             <Tooltip id="tooltip-icon" title="Delete">
               <div>    
                <Button variant="fab" mini  aria-label="Delete" onClick={()=> deleteApolloItem(row.id,props)} >
                    <Delete />
                </Button>
               </div>
             </Tooltip>
           </div>    
        )
      default:  
        return (
            <span onClick={()=>editApolloItem(row.id,props)} 
                className='editLink'>
                {row[col.id]}
            </span>
        )
    }
}

const addButtonOnclick=(e,props)=>{
    e.preventDefault();
    props.openAddInvItemForm();
}

const handleRowSelection=(selectedRows,props)=>{
    if (selectedRows.length){
        const index=selectedRows[selectedRows.length -1 ];
        props.invItemSelected(index);
    } else {
       props.invItemDeselected();
    }
}

const isSelected = (index,props) => {
    const { projApollo } = props;
    if (typeof projApollo.invoiceItemSelectedIndex=='number' && index === projApollo.invoiceItemSelectedIndex) {
        return true;
    }else {
        return false;
    }
}

const removeInvoiceItem=(e,props)=>{
    e.preventDefault();
    const { projApollo } = props;
    const { invoiceItems,lastInvoiceItemSelectedIndex } = projApollo;
    props.removeAnInvoiceItem(invoiceItems,lastInvoiceItemSelectedIndex);
}

const calculateTotalOfColM=projApollo=>{
    const total = projApollo.apolloItems.length>0? 
    projApollo.apolloItems.map(item=> parseFloat(item.item_charge)).reduce((prev,next)=> prev + next):0;
    return total.toFixed(2);
}

class InvoiceItemsForm extends React.Component {
    componentWillMount(){
        this.refreshData();
    }

    componentDidMount(){
    }

    componentDidUpdate(){
        const { projApollo } = this.props;
        if (projApollo.anyChanges){
            this.refreshData();
        }
    }

    refreshData(){
        const { projApollo,jwt,taskAcceptedInfoId } = this.props;
        const { page,pageSize,sortField,sortOrder } = projApollo;
        this.props.getApolloItems(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId);
    }

    handleChangePage = (event, page) => {
        const nextPage=page+1;    
        const { jwt,projApollo } = this.props;
        this.props.setPage(jwt,projApollo,nextPage);
    };
  
    handleChangeRowsPerPage = event => {
        const pageSize=event.target.value;
        const { jwt,projApollo } = this.props;
        this.props.setPageSize(jwt,projApollo,pageSize);
        
    };

    handleRequestSort = (event, property) => {
        let order = 'desc';

        const { jwt,projApollo  } = this.props;
        const { sortField,sortOrder } = projApollo;
    
        if (sortField === property && sortOrder === 'desc') {
            order = 'asc';
        }
        
        //this.props.sortData(gs.jwtToken,wrk,property,order)
    };

    handleClick = (event, id)=> {
       /* const { projApollo } = this.props;
        const apolloItem = projApollo.apolloItems.find(item => item.id==id)
        
        this.props.editApolloItem(apolloItem);*/
    }

    handleSearch=(search)=>{
    }

    render(){
        const { projApollo } = this.props;
    
        return (
            <div>
                <Paper>
                    <div className='container'>
                        <ContainerRowSpace />
                        <div className='row'>
                            <div className="col-sm-4">
                            </div> 
                            <div className="col-sm-3">
                            </div>  
                            <div className="col-sm-4">
                            Total of Column M: <span className="font-weight-bold">{projApollo.totalSumOfItemCharge}</span>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm'>
                                <EnhancedDataTable 
                                    title={'Invoice Items'}    
                                    //selected={selected}
                                    totalRows={projApollo.count}
                                    order={projApollo.sortOrder}
                                    orderBy={projApollo.sortField}
                                    rowsPerPage={projApollo.pageSize}
                                    page={projApollo.page - 1}
                                    data={projApollo.apolloItems}
                                    handleSearch={this.handleSearch}
                                    columnData={columnData}
                                    //handleSelectAllClick={this.handleSelectAllClick}  
                                    handleRequestSort={this.handleRequestSort}
                                    handleClick={this.handleClick}
                                    //handleKeyDown={this.handleKeyDown}
                                    handleChangePage={this.handleChangePage}
                                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    tableStyle={{width: '180%',minWidth: 800}}
                                    customColFunc={customCol}
                                    showToolbar={true}
                                    addNewOnclick={(e)=> addButtonOnclick(e,this.props)}
                                    clientUiProps={this.props}    
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-sm'>
                                <ActionConfirmDialog2 
                                    title={'Invoice Items'}
                                    message={'Are you sure you want to delete this item?'}
                                    submitFunc={()=> submitConfirmDelete(this.props)}
                                /> 
                            </div>
                        </div>   
                        <ContainerRowSpace /> 
                    </div> 
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        projApollo: state.projApollo
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getApolloItems: (jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId) => {
            dispatch(actions.getApolloItems(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId))
        },
        setPage: (jwt,projApollo,page)=>{
          dispatch(actions.setPage(jwt,projApollo,page))
        },
        setPageSize: (jwt,projApollo,pageSize)=>{
          dispatch(actions.setPageSize(jwt,projApollo,pageSize))
        },
        editApolloItem: (apolloItem)=>{
            dispatch(actions.editApolloItem(apolloItem))
        }, 
        openAddInvItemForm: () => {
            dispatch(actions.openAddInvItemForm())  
        },
        moveDownApolloItem: (jwt,id)=>{
            dispatch(actions.moveDownApolloItem(jwt,id))
        },
        moveUpApolloItem: (jwt,id)=>{
            dispatch(actions.moveUpApolloItem(jwt,id))
        },
        deleteApolloItem: (jwt,id)=>{
            dispatch(actions.deleteApolloItem(jwt,id))
        },
        invItemSelected: (index) => {
            dispatch(actions.invItemSelected(index))  
        },
        invItemDeselected: () => {
            dispatch(actions.invItemDeselected())  
        },
        removeAnInvoiceItem: (currentInvItems,index) => {
            dispatch(actions.removeAnInvoiceItem(currentInvItems,index));  
        },
        deleteActionDialog: ()=> {
            dispatch(actConfDlgActions.openDialog2())    
        },
        closeDeleteDialog: ()=> {
            dispatch(actConfDlgActions.closeDialog2())    
        },
        selectApolloItemId: (id)=> {
            dispatch(actions.selectApolloItemId(id))    
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceItemsForm);


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/InvoiceItemsForm.js